import { Helpers } from '../../helpers';
import { ICostType } from '../../interfaces/icost-type';
import { BudgetAdjustment } from '../budget-adjustment';
import { CostCodeCostType } from '../cost-code-cost-type';
import { CostTypeCategory } from '../cost-type-category';

export class CostTypeBase {
  CostTypeId: number;
  CostTypeValue: number;
  CostTypeDescription: string;
  CostTypeCategoryId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  IsActive: boolean | null;

  BudgetAdjustments_CostType?: Array<BudgetAdjustment> | null;
  CostCodeCostTypes_CostType?: Array<CostCodeCostType> | null;
  CostTypeCategory?: CostTypeCategory;

  constructor(item?: ICostType) {
    if (item) {

      this.CostTypeId = item.CostTypeId;
      this.CostTypeValue = item.CostTypeValue;
      this.CostTypeDescription = item.CostTypeDescription;
      this.CostTypeCategoryId = item.CostTypeCategoryId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.IsActive = item.IsActive;

      this.BudgetAdjustments_CostType = Helpers.createClassArray(BudgetAdjustment, item.BudgetAdjustments_CostType);
      this.CostCodeCostTypes_CostType = Helpers.createClassArray(CostCodeCostType, item.CostCodeCostTypes_CostType);
      this.CostTypeCategory = new CostTypeCategory(item.CostTypeCategory);
    }
  }
}